/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 31/05/2023.
 */
import React, { useState } from 'react'
import { LINOLEUM_TEXT, PAINTED_TEXT, titleLookUp, VENEER_TEXT } from '../../constant'
import Button from '../Button'

const priceConfigArr = [
  { title: 'Linoleum', text: LINOLEUM_TEXT },
  { title: 'Finér', text: VENEER_TEXT },
  { title: 'Malet', text: PAINTED_TEXT },
  { title: 'Laminat', text: 'laminat' },
]

const KitchenPriceList = ({ priceRef, metodPrices, product }) => {
  const onlyPainted = metodPrices.productId === '9' || metodPrices.productId === '8'
  const startIndex = onlyPainted ? 2 : 0

  const [selectedIndex, setSelectedIndex] = useState(startIndex)
  const [showAll, setShowAll] = useState(false)

  const itemClick = (index) => {
    setSelectedIndex(index)
  }

  const toggleShowAll = () => {
    if (showAll) {
      priceRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    setShowAll(!showAll)
  }

  const priceList = showAll ? metodPrices.data : metodPrices.data.slice(0, 4)

  const handleKeyDown = (ev) => {
    // check keys if you want
    if (ev.keyCode === 13) {
    }
  }

  return (
    <>
      <div ref={priceRef} className="container-fluid bg-white px-0">
        <div className="container py-5 ">
          <div className="row" style={{}}>
            <div className="col-12 ps-4 ">
              <p className="mb-md-2 mb-1 opacity-75">Størrelser og materiale</p>
              <h3 className="fw-bold mb-4 ">Her finder du {product.name} priser</h3>
            </div>
          </div>
        </div>

        <div className="container ">
          <div className="row " style={{}}>
            <div className="col-12 col-md-8 ps-md-4 ">
              <div className="row">
                {priceConfigArr.map((item, index) => {
                  const isSelected = index === selectedIndex

                  const hide = onlyPainted && (index < 2 || index === 3)

                  if (hide) {
                    return null
                  }

                  return (
                    <div
                      key={index}
                      className="col-3 col-md-3 h-100 pointer noselect "
                      role="button"
                      onKeyDown={handleKeyDown}
                      tabIndex={0}
                      onClick={() => {
                        itemClick(index)
                      }}
                    >
                      <p className="fw-bold py-2 text-center text-md-start" style={{ opacity: isSelected ? 1 : 0.5 }}>
                        <span className="d-none ps-2 d-md-inline-block pe-2">{product.name} </span>
                        {item.title}
                      </p>
                      {isSelected ? <div className="w-100" style={{ height: 3, background: 'black' }}></div> : null}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid " style={{ background: '#f6f6f6' }}>
        <div className="container ">
          <div className="row" style={{}}>
            <div ref={priceRef} className="col-12 col-md-12 mx-auto">
              <div className="row d-none d-md-block">
                <div className="col-12 mb-5 mb-md-5 px-0 px-md-4 border-bottom py-6 ">
                  <div className="row " style={{}}>
                    <div className="col-6 d-flex align-items-center">
                      <p className="ms-md-2 fw-bold ">Størrelse</p>
                    </div>
                    <div className="col-3 d-flex align-items-center">
                      <div className="fw-bold">Materiale</div>
                    </div>

                    <div className="col-3 d-flex justify-content-end align-items-center">
                      <p className="fw-bold ">Pris</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row" style={{}}>
                {priceList.map((item, index) => {
                  return (
                    <div key={index} className="col-12 pt-5 pt-md-0 mb-3 mb-md-5 px-md-4 px-0 ">
                      {selectedIndex === 0 ? (
                        <div className="row border-bottom pb-5 " style={{}}>
                          <div className="col-12 col-md-6 d-flex align-items-center mb-4 py-md-2">
                            {/*<div className="rounded-pill bg-black text-white py-2 px-3">
                            <p className="fw-bold ">{item.title} cm</p>
                          </div>*/}
                            <div className="bg-white  py-2 px-3 " style={{ border: '1px solid rgba(0,0,0,.4)' }}>
                              <p className="fw-bold ">{item.title} cm</p>
                            </div>
                          </div>
                          <div className="col-8 col-md-3 ">
                            <p className="">{titleLookUp['linoleum_oak']}</p>
                            <p className="">{titleLookUp['linoleum_smooked_oak']}</p>
                            <p className="">{titleLookUp['linoleum_wallnut']}</p>
                          </div>

                          <div className="col-4 col-md-3 d-flex justify-content-end">
                            <div className="">
                              <p className="  ">{item.linoleum_oak_metod} dkk</p>
                              <p className=" ">{item.linoleum_smooked_oak_metod} dkk</p>
                              <p className=" ">{item.linoleum_wallnut_metod} dkk</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {selectedIndex === 1 ? (
                        <div className="row border-bottom pb-5 " style={{}}>
                          <div className="col-12 col-md-6 d-flex align-items-center mb-4 py-md-2">
                            {/*<div className="rounded-pill bg-black text-white py-2 px-3">
                            <p className="fw-bold ">{item.title} cm</p>
                          </div>*/}
                            <div className="bg-white  py-2 px-3 " style={{ border: '1px solid rgba(0,0,0,.4)' }}>
                              <p className="fw-bold ">{item.title} cm</p>
                            </div>
                          </div>
                          <div className="col-8 col-md-3 ">
                            <p className="">{titleLookUp['oak_veneer']}</p>
                            <p className="">{titleLookUp['wallnut_veneer']}</p>
                            <p className="">{titleLookUp['smooked_oak_veneer']}</p>
                          </div>

                          <div className="col-4 col-md-3 d-flex justify-content-end">
                            <div className="">
                              <p className="  ">{item.oak_veneer_metod} dkk</p>
                              <p className=" ">{item.wallnut_veneer_metod} dkk</p>
                              <p className=" ">{item.smooked_oak_veneer_metod} dkk</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {selectedIndex === 2 ? (
                        <div className="row border-bottom pb-2 " style={{}}>
                          <div className="col-12 col-md-6 d-flex align-items-center mb-4 py-md-2">
                            {/*<div className="rounded-pill bg-black text-white py-2 px-3">
                            <p className="fw-bold ">{item.title} cm</p>
                          </div>*/}
                            <div className="bg-white  py-2 px-3 " style={{ border: '1px solid rgba(0,0,0,.4)' }}>
                              <p className="fw-bold  ">{item.title} cm</p>
                            </div>
                          </div>
                          <div className="col-8 col-md-3 ">
                            <p className="mt-3">{titleLookUp['painted_method']}</p>
                          </div>

                          <div className="col-4 col-md-3 d-flex justify-content-end">
                            <div className="">
                              <p className="mt-3 ">{item.painted_metod} dkk</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {selectedIndex === 3 ? (
                        <div className="row border-bottom pb-5 " style={{}}>
                          <div className="col-12 col-md-6 d-flex align-items-center mb-4 py-md-2">
                            {/*<div className="rounded-pill bg-black text-white py-2 px-3">
                            <p className="fw-bold ">{item.title} cm</p>
                          </div>*/}
                            <div className="bg-white  py-2 px-3 " style={{ border: '1px solid rgba(0,0,0,.4)' }}>
                              <p className="fw-bold ">{item.title} cm</p>
                            </div>
                          </div>
                          <div className="col-8 col-md-3 ">
                            <p className="">{titleLookUp['oak_laminat']}</p>
                            <p className="">{titleLookUp['wallnut_laminat']}</p>
                            <p className="">{titleLookUp['smooked_oak_laminat']}</p>
                          </div>

                          <div className="col-4 col-md-3 d-flex justify-content-end">
                            <div className="">
                              <p className="">{item.oak_veneer_metod} dkk</p>
                              <p className=" ">{item.wallnut_veneer_metod} dkk</p>
                              <p className=" ">{item.smooked_oak_veneer_metod} dkk</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {/*                      <div
                        className="px-4 px-md-6 py-5 py-md-6 bg-white "
                        style={{ boxShadow: '0px 2px 30px -10px rgba(0, 0, 0, .02)' }}
                      >
                        <div className="d-flex mb-3 pb-md-3 justify-content-between align-items-center">
                          <h5 className="fw-bold pe-4">Skuffe front</h5>
                          <div className="d-flex flex-grow-1 " style={{ background: 'black', height: 1 }}></div>
                          <h5 className="ps-4 fw-bold align-self-end ">{item.title}</h5>
                        </div>





                        {selectedIndex === 2 ? (
                          <div className="d-flex justify-content-between mt-3">
                            <p className="">{titleLookUp['painted_metod']}</p>
                            <p className="">{item.painted_metod} dkk</p>
                          </div>
                        ) : null}
                      </div>*/}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="row" style={{}}>
            <div className="col-12 col-lg-4 col-md-5  mx-auto mb-2 mt-4">
              <Button
                className="py-3"
                //labelStyle={{ fontSize: '1.2rem' }}
                onClick={toggleShowAll}
                title={`Se flere ${product.name} priser`}
              ></Button>
            </div>
          </div>
          <div className="row" style={{}}>
            <div className="col-12 mt-4 mb-6">
              <p className="opacity-75 p-small text-center">
                Der tages forbehold for eventuelle korrektur- og prisfejl
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default KitchenPriceList
